import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import bigQueryMetricRecorder from '../../../v2/tracking/bigQueryMetricRecorder';
import Track from '../../../v2/utils/tracking';
import Comodo from './Comodo/Comodo';
import Entrust from './Entrust/Entrust';
import DefaultSecurityCert from './DefaultSecurityCert/DefaultSecurityCert';

import useStyles from './SecurityCertificate.styles';

export function SecurityCertificate(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const trackEvent = () => {
    try {
      bigQueryMetricRecorder('SecurityCertClick');
    } catch (error) {
      Track.track(error);
    }
  };
  
  if (!props.authority) return null;
  
  const getCertificateComponent = () => {
    switch (props.authority) {
      case 'comodo':
        return <Comodo />;
      case 'entrust':
        return <Entrust />;
      case 'default':
        return <DefaultSecurityCert props />;
      default:
        return null;
    }
  };
  
  return (
    // clickable for tracking purposes only
    // eslint-disable-next-line
    <div
      data-test="SecurityCertificate"
      className={classes.securityCert}
      onClick={trackEvent}
    >
      {getCertificateComponent()}
    </div>
  );
}

const mapStateToProps = state => ({
  authority: state.start.settings.security_certificate && state.start.settings.security_certificate.authority,
});

SecurityCertificate.defaultProps = {
  authority: null,
};

SecurityCertificate.propTypes = {
  authority: PropTypes.string,
  isRTL: PropTypes.bool,
};

export default connect(
  mapStateToProps,
)(SecurityCertificate);
